module.exports = __webpack_public_path__ + "static/media/triangle.b7218605.png";